import React, { FC } from 'react';
import Logo from '../../../../assets/images/logoBrizTV.svg';
import './BrizTvIcon.scss';

export const BrizTvIcon: FC = () => {
  return (
    <div className="briz-tv">
      <img src={Logo} alt="BRIZ.TV logo" />
    </div>
  );
};
